module.exports = __webpack_public_path__ + "static/media/papa-head-small.766c029e.svg";